import React, {useState, useEffect}from 'react';
import {useTranslation} from "react-i18next";
import DaohuuLayoutComponent from '@app/pages/FUtil/DaohuuLayoutComponent';
import {Button, Modal} from "react-bootstrap";
import {myService} from '@app/services/sukienService';
import DaohuuAutocompleteComponent from '@app/pages/FUtil/DaohuuAutocompleteComponent';
import MoiquanheListComponent from '@app/pages/FUtil/MoiquanheListComponent';
import {alertService} from '@app/services/alertService';
import {ClipLoader} from "react-spinners";
import TrangthaiListComponent from "@pages/FUtil/TrangthaiListComponent";
import ImportErrorTable from "@pages/FUtil/ImportErrorTable";
import {getFormData} from "@app/utils/CommonFunctions";
import {uploadService} from "@app/services/uploadService";
const DaohuuthamgiaEdit = ({id, allowEdit}) => {
    const [loading, setLoading] = useState(false);
    const [handleToogle, setHandleToogle] = useState(false);
    const [t] = useTranslation();
    const [daohuuList, setDaohuuList] = useState([]);
    const initial = {
        daohuuObj:null, // gọi trên BE tương tự daohuuObj
        trangthai_fk: null
    }
    const [isViewDaohuu,setIsViewDaohuu] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [obj, setObj] = useState({...initial});

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [importErrors, setImportErrors] = useState([]);
    const [importErrorsTitle, setImportErrorsTitle] = useState('');
    const [importcolumnError, setImportcolumnError] = useState('');

    const importClick = async () => {
        if (!fileUpload) {
            alertService.error("Vui lòng chọn file");
            return;
        }

        setLoading(true);
        const form = getFormData({ fileUpload, uploadType: 'SUKIEN_THAMGIA_TYPE', secret_key: id });

        try
        {
            const result = await uploadService.ImportStandard(form);
            if (result) {
                if (result.status === "1") {
                    alertService.success(result.msg);
                    // Refresh the data after successful import
                    await loadRef();
                    // Clear the file input
                    setFileUpload(null);
                    const fileInput = document.getElementById('fileUpload');
                    if (fileInput) fileInput.value = '';
                } else {
                    // Show dynamic table with error data
                    setImportErrors(result.data || []);
                    setImportErrorsTitle(result.msg || 'Import thất bại')
                    setImportcolumnError(result.data2 || '')
                    setShowErrorModal(true);
                    alertService.error(result.msg || 'Import thất bại');
                }
            } else {
                alertService.error('Có lỗi xảy ra trong quá trình import');
            }
        } catch (error) {
            console.error('Import error:', error);
            alertService.error('Có lỗi xảy ra trong quá trình import');
        } finally {
            setLoading(false);
        }
    };
    /// upload
    const [fileUpload, setFileUpload] = useState(null);
    // Simplified input change handler
    const onchangeInput = async (name, e) => {
        const { files} = e.target;
        setFileUpload(files[0]);
    }

    const saveClick = async () => {
      
        let data = obj;
        if(!data)
        {
            alert('Không xác định được trang vui lòng tải lại');
            return;
        }
       
        if(!data.trangthai_fk || data.trangthai_fk.length === 0)
        {
            alert('Vui lòng chọn trạng thái');
            return;
        }
        if(!data.daohuuObj )
            {
                alert('Vui lòng chọn đạo hữu');
                return;
            }
                   
                


            create(data);

    };

     const loadRef = async () => {
         const tmp = await myService.getRefById(id,'sukien_daohuuthamgia',{});
         setDaohuuList(tmp);
         setIsViewDaohuu(true);
           setHandleToogle((prevSelected) => {
            return !prevSelected;
        });
    };
     const deletedonhang = async (rowIndex) => {

             const { id } = daohuuList[rowIndex]
             try {
                 const result = await myService.Delete_Daohuuthamgia(id);
                 if (result.status === "1") {
                     alertService.success(t('fields.label.xoathanhcong'));
                     await loadRef();
                 } else {
                     alertService.error(result.msg);
                 }
             } catch (error) {
                 alertService.error('Có lỗi xảy ra khi xóa dữ liệu');
             }
        };
    const onChangeInput =  (e) => {
        const {name, value, checked} = e.target;


        setObj((prevState) => ({
            ...prevState,
            [name]: value
        }));


    };

    async function create(data) {
            setLoading(true);
            // delete data.ma;
            const result = await myService.Create_Daohuuthamgia(id,data);
            if (result.status ==="1") {
                alertService.success(result.msg);
                
                await loadRef();
                setShowModal(false);
                setIsViewDaohuu(true);
    
            } else {
                alertService.error(result.msg);
            }
            setLoading(false);
        }
      
    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }
        
    return  <>
                                       
                            {  isViewDaohuu ? ( <Button
                                className = "btn btn-secondary  mr-1" 
                            
                                aria-label="Close" 
                                onClick={() => { setIsViewDaohuu(false); setDaohuuList([]) }}
                                >
                                <span aria-hidden="true">Ẩn</span>
                                </Button>) : (<Button className="btn btn-info  mr-1"  onClick={() => loadRef()}>
                                                <i className="fa fa-arrow-down"> {"Xem"}</i>
                                            </Button>
                                            )   

                            }
                            {
                                allowEdit &&  isViewDaohuu && ( <Button
                                    className="btn  btn-success  mr-1"
                                    
                                    icon="right fas fa-angle-left"
                                    onClick={() => { setShowModal(true); setObj({...initial}) }}
                                >
                                <i className="fa fa-save"> {"Thêm"  } </i>
                                        </Button> )
                            }
        {
            allowEdit && isViewDaohuu && ( <div className="row">

                <div className="col-md-4">
                    <label className="required"htmlFor="fileUpload">Import dữ liệu</label>
                    <div className="input-group">
                        <input
                            id='fileUpload'
                            name="fileUpload"
                            type="file"
                            className="form-control  mr-1"
                            onChange={(e) => onchangeInput('fileUpload', e)}
                        />
                        <Button
                            type="button"
                            className="btn btn-success"
                            onClick={importClick}
                        >
                            <i className="fa fa-plus"></i> Upload
                        </Button>
                    </div>
                </div>
            </div>)
        }

                                <hr/>
                        { 
                            isViewDaohuu &&
                            (<div className="row table-responsive">
                                <div className="col-md-12">
                                    <table responsive bordered hover className="table table-bordered table-hover text-nowrap">
                                        <thead>
                                        <tr>
                                                              
                                            <th className="col-md-8 text-center">Đạo hữu</th>
                                            <th className="col-md-2 text-center">Trạng thái</th>
                                            <th className="col-md-2 text-center">Tác vụ</th>
                                        </tr>
                                        </thead>
                                        <tbody>

                                        {
                                            daohuuList && daohuuList.length > 0 &&  daohuuList.map((item, index) => {

                                                return (
                                                    <tr>
                                                        <td> <DaohuuLayoutComponent
                                                        
                                                            currentSuggestion = {item}
                                                            /></td>
                                                      
                                                      <td className="text-center">
                                                      <div className="form-group">
                                                      <div className="form-control d-flex align-items-center">
                                                            {item.trang_thai}
                                                            </div>
                                                            </div>
                                                            </td>
                                                        <td className="text-center">
                                                            { allowEdit && (<a
                                                                className="btn"
                                                                key={`delete-daohuuchitiet-${index}`}
                                                                title={t('action.label.delete')}
                                                                onClick={() => {
                                                                    if (window.confirm(t('fields.label.bancomuonxoa')))
                                                                        deletedonhang(index);
                                                                }}
                                                            >
                                                                <i className="fas fa-times-circle text-danger mr-2" />
                                                            </a>) }
                                                        </td>
                                                        
                                                    </tr>
                                                );


                                            })

                                        }
                                        </tbody>
                                    </table>
                            </div>

                        </div>)
                        }
            <Modal size="lg" show={showModal} onHide={() => { setShowModal(false)}}>
                <Modal.Header>
                    <Modal.Title>
                       Thông tin đạo hữu
                       </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='form-group'>
                        <label htmlFor="Note">Đạo hữu</label>
                        <DaohuuAutocompleteComponent
                              
                                    currentSuggestion={obj.daohuuObj}


                                    onChange={(e) =>
                                            {   
                                                const target =     {name:'daohuuObj', value: e?.value};
                                                onChangeInput( { target } )
                                        
                                            }
                                        }
                                    >
                        </DaohuuAutocompleteComponent>
                    </div>    
                    <div className='form-group'>

                        <TrangthaiListComponent trangthai_fk = {obj.trangthai_fk}
                                                onChange ={(opt, e) => {
                                                    const target = {name: "trangthai_fk", value: opt?.value};
                                                    onChangeInput({target});

                                                }}
                                                filterIds = { [0,1] }
                                                trangthaiName = "thamgia"
                        />
                                    
                    </div>                  
                                    
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {setShowModal(false); }}>
                        {"Thoát"}
                    </Button>
                    {allowEdit && ( <Button variant="primary" onClick={saveClick}>
                        {"Xác nhận"}
                    </Button>) }
                    

                </Modal.Footer>
            </Modal>
        <ImportErrorTable
            columnError = {importcolumnError}
            show={showErrorModal}
            onHide={() => setShowErrorModal(false)}
            data={importErrors}
            title={importErrorsTitle}
            column
        />
                                       
       </>
};

export default DaohuuthamgiaEdit;
